<template>
  <div>
    <van-field
      v-model="cReturnGoodsBatchNo"
      name="退货批次"
      label="退货批次"
      placeholder="请填写退货批次"
    />
    <van-field
      v-model="cRemark"
      name="备注"
      label="备注"
      placeholder="请填写备注"
    />
    <div class="subBtn" @click="subForm()">下一步</div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, List, Cell, Toast, Form, Field, Popup, Picker } from "vant";

export default {
  data() {
    return {
      value: "",
      columns: [],
      columnsVal: [],
      showPicker: false,
      cRemark: "",
      cReturnGoodsBatchNo: "",
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  methods: {
    subForm() {
      if (this.cReturnGoodsBatchNo == "") {
        Toast("请填写退货批次");
        return;
      }
      var dd = {
        active: 1,
        cRemark: this.cRemark,
        cReturnGoodsBatchNo: this.cReturnGoodsBatchNo,
      };
      this.$emit("changeData", dd);
    },
  },
  created: function () {},
};
</script>
<style scoped>
.searchBox {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: white;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;

  width: 355px;
  z-index: 99;
}
.searchBox img {
  width: 28px;
  flex-shrink: 0;
  height: 28px;
  margin-left: 20px;
}
.searchBox input {
  width: 100%;
  height: 30px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
}

.numberBox {
  font-size: 20px;
  margin-top: 10px;
}
.subBtn {
  width: 200px;
  margin: 0 auto;
  background: #e62129;
  color: white;
  font-size: 16px;
  border-radius: 5px;
  line-height: 36px;
  height: 36px;
  margin-top: 40px;
}
</style>
